import { render } from "./MarketModal.vue?vue&type=template&id=b1a3bd08&scoped=true"
import script from "./MarketModal.vue?vue&type=script&lang=js"
export * from "./MarketModal.vue?vue&type=script&lang=js"

import "./MarketModal.vue?vue&type=style&index=0&id=b1a3bd08&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1a3bd08"]])

export default __exports__